// Services/_selectors.js
import { selector } from 'recoil';
import APIService from '../../APIService';
import { Apis } from '../../app.constants';
import { RecoilAtomKey } from '../../recoilConstantKey';
import { generateFilterKey } from '../../../utils/helper';
import { InvoiceProposalsAtom } from './DecisionBoard';

export const fetchInvoiceProposalsSelector = selector({
  key: RecoilAtomKey.fetchInvoiceProposalsSelectorKey,
  get: async ({ get }) => {
    const state = get(InvoiceProposalsAtom);
    const filterKey = generateFilterKey(state.filters);

    if (state.cache[filterKey]) {
      return {
        data: state.cache[filterKey],
        totalCount: state.totalCountCache[filterKey],
        fromCache: true,
      };
    }

    try {
      // Extract values from filters
      const page = state.filters?.page || 0;
      const search = state.filters?.search || '';

      const queryParams = new URLSearchParams({
        next_page: (page + 1).toString(),
        search
      }).toString();

      const response = await APIService.get(`${Apis.Get_Invoice_Proposals}?${queryParams}`);
      
      if (response?.status === 200) {
        return {
          data: response?.data?.list || [],
          totalCount: response?.data?.count || 0,
          fromCache: false,
        };
      } else {
        return { data: [], totalCount: 0, fromCache: false };
      }
    } catch (error) {
      console.error('Error fetching invoice proposals:', error);
      return { data: [], totalCount: 0, fromCache: false };
    }
  },
});
